<template>
  <group :config="{...config, draggable}">
    <Label 
      :ref="`label-${name}`"
      :config="labelConfig"
      :scale="labelScale"
      :background-color="labelBackgroundColor"
    />
  </group>
</template>

<script>
import canvasElement from './mixins/canvasElement'
import withLabel from './mixins/withLabel'
import Group from './Group'
export default {
  name: 'DrawLabel',
  components: {Group},
  mixins: [canvasElement, withLabel],
  props: {
    height: {
      validator (value) {return !isNaN(value)},
      default: 100
    },
    width: {
      validator (value) {return !isNaN(value)},
      default: 100
    }
  },
  data () {
    return {}
  },
}
</script>